export default {
  greyLight: '#e0e4e4',
  grey: '#d9dedf',
  greyMedium: '#cecdcc',
  greyMediumer: '#616868',
  greyMediumest: '#5c6069',
  greyDark: '#3F4141',
  greyDarkish: '#2a2d33',
  greyDarker: '#1E252E',

  greyTealDark: '#789B9D',
  greyTeal: '#a3cacd',
  greyTealLight: '#bdedf1',

  blueLighter: '#B2BBEE',
  blueLight: '#808EE1',
  blue: '#576DE7',
  blueDark: '#273aa2',

  pinkLightest: '#D3BBF2',
  pinkLighter: '#D68DF0',
  pinkLight: '#EC75CB',
  pink: '#F95DB2',
  pinkDark: '#e86ebf',

  greenLighter: '#E7FFED',
  greenLight: '#ACFFC3',
  green: '#85EBA2',
  greenDark: '#59DF7F',

  tealLighter: '#94eeee',
  tealLight: '#65e0e0',
  teal: '#41c7c7',
  tealDark: '#2ba7a7',
  tealDarker: '#1d7e7e',

  purpleLight: '#B096E7',
  purple: '#7854C3',
  purpleDark: '#57457C',

  redLighter: '#f8a8a8',
  redLight: '#fc8f8f',
  red: '#FE6A6A',
  redDark: '#ec5555',
  redDarker: '#D13F3F',

  orangeDarker: '#ab5a0e',
  orangeDark: '#ce7019',
  orange: '#EF8D33',
  orangeLight: '#ffa958',
  orangeLighter: '#fdbd81',

  yellowDark: '#afa81f',
  yellow: '#fbf34c',
  skyblueDark: '#1372ad',
  skyblue: '#1ea0f2',
  oliveDark: '#3c7920',
  olive: '#599E38',
  aquaDark: '#1d847d',
  aqua: '#3ABBB3',
  indigo: '#4861EC',

  white: '#ffffff',

  navyLightest: '#7e86ad',
  navyLighter: '#484F73',
  navyLight: '#303652',
  navy: '#232840',
  navyDark: '#1a1f35',
}
